import { VideoStore } from "@/front/stores/video_store.js";
import { PlaybackStore } from '@/front/stores/playback_store.js';
import { LeadCaptureStore } from '@/front/stores/lead_capture_store.js';
import { MessageComposer } from '@/front/composables/MessageComposer.js';

export function usePlaybackInitializer() {
  const videoStore = VideoStore();
  const playbackStore = PlaybackStore();
  const leadCaptureStore = LeadCaptureStore();
  const { receiveMessage } = MessageComposer();
  let paymentStore = null;

  const initialize = async (route) => {
    log.info(2,"💟 Initialize playback")
    window.addEventListener('message', receiveMessage);
    
    if (videoStore.video.capture_payment_point > -1) {
      const { PaymentStore } = await import('@/front/stores/payment_store.js');
      paymentStore = PaymentStore();
      paymentStore.setConfig(videoStore.video);
    }

    videoStore.video.manage = false;
    playbackStore.initialize(route, false);
    log.info(1,"💟 Variables after initialize", playbackStore.variables)
    if (playbackStore.variables.SKIP_LEAD) {
      log.info(1,"💟 Skip lead")
      leadCaptureStore.shown = true
    } else {
      log.info(1,"💟 Set lead capture config")
      leadCaptureStore.setConfig(videoStore.video);
    }

    if (videoStore.video.collect_geolocation) {
      navigator.geolocation.getCurrentPosition(
        pos => {
          playbackStore.latitude = pos.coords.latitude;
          playbackStore.longitude = pos.coords.longitude;
        },
        null,
        {maximumAge:60000, timeout:5000, enableHighAccuracy:true}
      );
    }
  };

  return {
    initialize
  };
} 